import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useQueryClient } from "@tanstack/react-query";
import { refreshAuthSession, useAuthSession } from "../apis/Auth";
import { SigninWithGoogle } from "../apis/Users.js";
import naverLoginBtn from "../assets/img/NAVER_login_Dark_KR_green_wide_H48.png";
import kakaoLoginBtn from "../assets/img/kakao_login_large_wide.png";
import { clearGuestAccess } from "../utils/guestAccess";

/* const NaverLogin = () => {
  const NAVER_CLIENT_ID = process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID;
  const NAVER_CALLBACK_URL = process.env.REACT_APP_NAVER_CALLBACK_URL;
  const STATE = "false";
  const naverAuthUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&state=${STATE}&redirect_uri=${NAVER_CALLBACK_URL}`;

  const handleNaverLogin = () => {
    window.location.href = naverAuthUrl;
  };

  return (
    <img
      src={naverLoginBtn}
      alt="네이버 로그인"
      onClick={handleNaverLogin}
      style={{ cursor: "pointer", height: 48, width: "100%" }}
    />
  );
} */

const KakaoLogin = () => {
  const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO_LOGIN_CLIENT_ID;
  const KAKAO_CALLBACK_URL = process.env.REACT_APP_KAKAO_CALLBACK_URL;
  const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_CLIENT_ID}&redirect_uri=${KAKAO_CALLBACK_URL}`;

  const handleKakaoLogin = () => {
    window.location.href = kakaoAuthUrl;
  };

  return (
    <img
      src={kakaoLoginBtn}
      alt="카카오 로그인"
      onClick={handleKakaoLogin}
      style={{ cursor: "pointer", height: 48, width: "100%" }}
    />
  );
}

export default function Signin() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const authQuery = useAuthSession();
  const redirectTo = location.state?.from?.pathname || "/";
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  useEffect(() => {
    if (!authQuery.data?.authenticated) {
      return;
    }

    clearGuestAccess();
    navigate(redirectTo, { replace: true });
  }, [authQuery.data?.authenticated, navigate, redirectTo]);


  return (
    <div className="page-sign">
      <Card className="card-sign">
        <Card.Header>
          <Link to="/" className="header-logo mb-4">WHISPER</Link>
          <Card.Title>Sign In</Card.Title>
          <Card.Text>보안을 위해 소셜 로그인으로 부탁해요.</Card.Text>

        </Card.Header>
        <Card.Body>
          <Form method="get" action="/dashboard/finance">
            <div className="mb-4">
              <Form.Label >Email address</Form.Label>
              <Form.Control type="text" placeholder="Enter your email address" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="mb-4">
              <Form.Label className="d-flex justify-content-between">Password <Link to="">Forgot password?</Link></Form.Label>
              <Form.Control type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <Button type="submit" variant="primary" className="btn-sign">Sign In</Button>

            <div className="divider"><span>or sign in with</span></div>

            <Row className="gx-2">
              {/* <div>
                <Col className="d-flex justify-content-center mb-2 w-100">
                  <NaverLogin />
                </Col>
              </div> */}
              <div>
                <Col className="d-flex justify-content-center mb-2">
                  <KakaoLogin />
                </Col>
              </div>
              <div>
                <Col className="d-flex justify-content-center mb-2">
                  <div className="google-login-custom">
                    <button type="button" className="google-login-custom-btn" tabIndex={-1}>
                      <span className="google-login-custom-icon" aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.64 9.2045c0-.6382-.0573-1.2518-.1636-1.8409H9v3.4818h4.8436c-.2087 1.125-.8427 2.0782-1.796 2.7164v2.2582h2.9087c1.7018-1.5664 2.6837-3.8741 2.6837-6.6155z" fill="#4285F4" />
                          <path d="M9 18c2.43 0 4.4673-.8059 5.9564-2.1791l-2.9087-2.2582c-.8059.54-1.8368.8591-3.0477.8591-2.3427 0-4.3268-1.5818-5.0359-3.7091H.9573v2.3318C2.4382 15.9864 5.4818 18 9 18z" fill="#34A853" />
                          <path d="M3.9641 10.7127C3.7841 10.1727 3.6818 9.5955 3.6818 9s.1023-1.1727.2823-1.7127V4.9555H.9573C.3477 6.17 0 7.5441 0 9s.3477 2.83.9573 4.0445l3.0068-2.3318z" fill="#FBBC05" />
                          <path d="M9 3.5782c1.3214 0 2.5077.4541 3.4418 1.3459l2.5814-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0136.9573 4.9555l3.0068 2.3318C4.6732 5.16 6.6573 3.5782 9 3.5782z" fill="#EA4335" />
                        </svg>
                      </span>
                      <span>Google로 로그인</span>
                    </button>
                    <div className="google-login-custom-overlay">
                      <GoogleLogin
                        size="large"
                        width={"100%"}
                        useOneTap={false}
                        onSuccess={async (res) => {
                          const idToken = res.credential;

                          if (!idToken) {
                            console.log('No ID token found');
                            return;
                          }

                          SigninWithGoogle(idToken).then(async (response) => {
                            const data = await response.json();
                            if (data.ok) {
                              clearGuestAccess();
                              await refreshAuthSession(queryClient);
                              navigate(redirectTo, { replace: true });
                              return;
                            } else if (data.status === "deleted") {
                              alert("탈퇴 처리된 계정입니다.");
                              navigate('/pages/signin');
                            } else if (data.status === "not_found") {
                              navigate(`/pages/signup?provider=google&temp_token=${data.temp_token}`);
                            } else {
                              console.log('Signin failed');
                            }
                          }).catch((error) => {
                            console.error('Error during signin:', error);
                          });
                        }}
                        onError={() => {
                          console.log('Login Failed');
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </div>
            </Row>
          </Form>
        </Card.Body>
        <Card.Footer>
          로그인과 함께 회원가입이 완료됩니다.
        </Card.Footer>
      </Card>
    </div>
  )
}
